import * as React from "react";
import { Drawer } from "@mui/material";
import { DrawerHeader } from "components/DrawerHeader/DrawerHeader";
import { DrawerBody } from "components/DrawerBody/DrawerBody";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { AiToolboxAction, SelectActionStep } from "./steps/SelectActionStep/SelectActionStep";
import { ImproveTranslationStep } from "./steps/ImproveTranslationStep/ImproveTranslationStep";
import { AddWatermarkStep } from "./steps/AddWatermarkStep/AddWatermarkStep";
import { MachineTranslationSettings } from "gen/clients/llts";

interface Props {
  mtSettings: MachineTranslationSettings;
  onClose: () => void;
  onSuccess: () => void;
}

enum Step {
  SELECT_ACTION = "SELECT_ACTION",
  IMPROVE_TRANSLATION = "IMPROVE_TRANSLATION",
  ADD_WATERMARK = "ADD_WATERMARK"
}

const CreateAiToolboxPanel: React.FC<Props> = ({ mtSettings, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [currentStep, setCurrentStep] = React.useState(Step.SELECT_ACTION);

  const onActionSelected = React.useCallback((action: AiToolboxAction) => {
    if (action === AiToolboxAction.IMPROVE_TRANSLATION) {
      setCurrentStep(Step.IMPROVE_TRANSLATION);
    } else if (action === AiToolboxAction.ADD_WATERMARK) {
      setCurrentStep(Step.ADD_WATERMARK);
    }
  }, []);

  return (
    <Drawer
      open={true}
      anchor="right"
      PaperProps={{ sx: { width: isSmallScreen ? "100vw" : "50vw" } }}
      onClose={onClose}
    >
      <DrawerHeader title={t("machineTranslation.aiToolbox.createPanelTitle")} onClose={onClose} />
      <DrawerBody>
        {currentStep === Step.SELECT_ACTION && <SelectActionStep mtSettings={mtSettings} onNext={onActionSelected} />}
        {currentStep === Step.IMPROVE_TRANSLATION && <ImproveTranslationStep onClose={onClose} onSuccess={onSuccess} />}
        {currentStep === Step.ADD_WATERMARK && <AddWatermarkStep onClose={onClose} onSuccess={onSuccess} />}
      </DrawerBody>
    </Drawer>
  );
};

export { CreateAiToolboxPanel };
